<p-card styleClass="detail-card">
  <div class="section-header">
    <div>
      <h3>Interventions proches</h3>
      <p>
        {{ interventions.length }} intervention{{
          interventions.length > 1 ? 's' : ''
        }}
        programmée{{ interventions.length > 1 ? 's' : '' }} à moins de
        {{ radiusKm }} km de {{ cityName }}
      </p>
    </div>
    <button
      type="button"
      class="close-btn"
      (click)="closed.emit()"
      aria-label="Fermer les interventions proches"
      title="Fermer"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>

  @if (loading) {
    <div class="empty-panel">
      <i class="pi pi-spin pi-spinner"></i>
      <p>Chargement des interventions…</p>
    </div>
  } @else if (interventions.length > 0) {
    <div class="tour-affairs-list">
      @for (item of interventions; track $index) {
        <button
          type="button"
          class="tour-affair-item nearby-item"
          [class.highlighted]="
            item.id != null && selectedInterventionId === item.id
          "
          (click)="interventionSelected.emit(item)"
        >
          <div class="item-topline">
            <span class="affair-name">{{ item.title }}</span>
            <span class="distance-chip">{{ item.distanceLabel }}</span>
          </div>
          <div class="item-meta">
            @if (item.location) {
              <div class="item-row">
                <i class="pi pi-map-marker"></i>
                <span>{{ item.location }}</span>
              </div>
            }
            @if (item.dateLabel) {
              <div class="item-row">
                <i class="pi pi-calendar"></i>
                <span>{{ item.dateLabel }}</span>
              </div>
            }
            @if (item.technicianName) {
              <div class="item-row">
                <i class="pi pi-user"></i>
                <span>{{ item.technicianName }}</span>
              </div>
            }
          </div>
        </button>
      }
    </div>
  } @else {
    <div class="empty-panel">
      <i class="pi pi-map"></i>
      <p>
        Aucune intervention programmée à moins de {{ radiusKm }} km de
        {{ cityName }}.
      </p>
    </div>
  }
</p-card>
